import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { PledgeDto } from 'src/app/revenue/shared/pledge/dto/pledge.dto';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { InvViewSearchDto } from 'src/app/revenue/shared/dto/inv-view-search.dto';
import { InvViewDto } from 'src/app/revenue/shared/dto/inv-view.dto';
import { MenuItem } from 'primeng/api';
import { FinancialServiceService } from 'src/app/revenue/shared/financial.service';
import { DatagridService, PagedResultGeneric, PagedSearch } from 'src/app/shared';

@Component({
  selector: 'wl-pledge-edit-invoices',
  templateUrl: './pledge-edit-invoices.component.html',
  styleUrls: ['./pledge-edit-invoices.component.less'],
    standalone: false
})
export class PledgeEditInvoicesComponent extends LazySelectableTableComponent<InvViewSearchDto, InvViewDto> implements OnInit, OnChanges {
  @Input() pledge: PledgeDto;

  rowMenuItems = new Map<number, MenuItem[]>();

  constructor(
    datagridService: DatagridService,
    public securityElementNames: SecurityElementNames,
    private _financialService: FinancialServiceService,
  ) {
    super('InvoiceLineItemLineItemId', datagridService);
    this.searchParams = new PagedSearch() as InvViewSearchDto;
  }

  ngOnInit(): void {}

  ngOnChanges(): void {
    this.searchParams.InvoiceLineItemPledgeId = this.pledge.PledgeId;
  }

  public fetchResults(): Promise<PagedResultGeneric<InvViewDto>> {
    return this._financialService.searchInvoiceLineItems(this.searchParams);
  }

  public pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }
}
